// Dependencies: none
define('instrumentation/util', [], function () {
    return {
        getLogTimestamp: function() {
            if (typeof window.performance !== 'undefined' && window.performance.now) {
                return window.performance.now();
            } else {
                return Date.now();
            }
        },

        uuid4: function() {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        getUtcTime: function() {
            return new Date().toUTCString();
        },

        ///// Added for CCUI since we do not have this function in $.advertiser
        getCookie: function(name) {
            var prefix = name + "=";
            var begin = document.cookie.indexOf(prefix);
            if (begin == -1) return null;

            var end = document.cookie.indexOf(";", begin);
            if (end == -1) end = document.cookie.length;

            return unescape(document.cookie.substring(begin + prefix.length, end));
        },

        ///// The utility functions below are taken from underscore.js, since these are the only functions we need from there.

        // Is a given variable an object?
        isObject: function(obj) {
            return obj === Object(obj);
        },

        // Is a given variable an array?
        isArray: function(arr) {
            return Array.isArray ? Array.isArray(arr) : Object.prototype.toString.call(arr) === '[object Array]';
        },

        // Is a given variable undefined?
        isUndefined: function(obj) {
            return obj === void 0;
        },

        // Returns the first function passed as an argument to the second,
        // allowing you to adjust arguments, run code before and after, and
        // conditionally execute the original function.
        wrap: function(func, wrapper) {
            return function() {
                var args = [func];
                Array.prototype.push.apply(args, arguments);
                return wrapper.apply(this, args);
            };
        },

        // Sets the url parameter value.  If url is not provided use window.location.href as the url
        // This function is forked from osd.ui.common.js ($.advertiser.setUrlParameter = function(){})
        // to remove all dependencies to $.advertiser in instrumentations libs
        setUrlParameter: function (name, value, url)
        {
            url = url || window.location.href;
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            value = value || '';
            var regex = new RegExp("([\\?&])" + name + "=.*?(&|$|#)");
            if (url.match(regex)){
                return url.replace(regex, "$1" + name + "=" + encodeURIComponent(value) + "$2");
            }
            var qs = url.indexOf("?") > -1 ? "&" : "?";
            qs += name + "=" + encodeURIComponent(value);
            var fragment = url.lastIndexOf("#");
            if (fragment > -1) {
                url += url.slice(0, fragment) + qs + url.slice(fragment);
            }
            else{
                url += qs;
            }
            return url;
        }
    };
});
